/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var DocActions;
    (function (DocActions) {
        const LOG_CATEGORY = "WPT.DocumentActions.Print";
        class DocActionPrint extends DocActions.DocActionBaseClass {
            constructor(core, name) {
                super(core, name);
                this._currentDocId = null;
                this._currentDoc = null;
                this._printUrl = null;
                this._printWindow = null;
                this._modalSession = null;
                this.actionAllowed = (request) => {
                    this._log.info("DocActionPrint.actionAllowed()");
                    let printPrivilege = true;
                    if (request.hasOwnProperty('DocumentType') && request.DocumentType) {
                        if (request.DocumentType.Name in this._core.OBHelper.DownloadDocumentTypeMap) {
                            let docType = this._core.OBHelper.DownloadDocumentTypeMap[request.DocumentType.Name];
                            printPrivilege = docType.Privileges.PrintDocument;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("print privilege? " + printPrivilege);
                            }
                        }
                    }
                    let result = printPrivilege;
                    if (printPrivilege) {
                        if (request.PropertyBag != null) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at properties: " + request.PropertyBag);
                            }
                            // don't allow print of Unity Forms
                            let fileTypeSetting = request.PropertyBag.find(setting => setting[0] === "FileType");
                            if (fileTypeSetting) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("looking at file type: " + fileTypeSetting[1]);
                                }
                                result = fileTypeSetting[1] !== "Unity Form";
                            }
                            if (result) {
                                // only allow print for PDF
                                let contentTypeSetting = request.PropertyBag.find(setting => setting[0] === "ContentType");
                                if (contentTypeSetting) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("looking at content type: " + contentTypeSetting[1]);
                                    }
                                    result = contentTypeSetting[1] === "application/pdf";
                                }
                            }
                        }
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("print action allowed? " + result);
                    }
                    return result;
                };
                this.needsDirectExecution = (request) => {
                    this._log.info("DocActionPrint.needsDirectExecution()");
                    // needs direct execution (iOS blocks opening windows if not directly executed on user input e.g. click)
                    return true;
                };
                this.execute = (request) => {
                    this._log.info("DocActionPrint.execute()");
                    let modalSession = 'print-doc-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modalType = WPTNamespace.ModalType.FIRST;
                    if (request.PropertyBag && request.PropertyBag.hasOwnProperty('ModalTypeToUse')) {
                        modalType = request.PropertyBag.ModalTypeToUse;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("trying to use modal type: " + WPTNamespace.ModalType[modalType]);
                    }
                    if (this._core.Helper.presentBusyModal(modalType, modalSession, "STR_WPT_PROCESSING")) {
                        this._modalSession = modalSession;
                    }
                    let width = 800;
                    let height = 800;
                    let top = (window.innerHeight - height) / 2;
                    let left = (window.innerWidth - width) / 2;
                    // can't use 'noopener,noreferrer' here, since the window object is NULL then, but we need it later to set URL (iOS won't allow later window opening)
                    this._printWindow = window.open('', 'WPT-Print', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got print window: " + this._printWindow);
                    }
                    // the _unloadPrint() was used to revoke the created object URL in order to prevent memory issues in the browser
                    // in Chrome however this leads to "network error" failure when the PDF should be downloaded
                    // this comment stays as a reminder once we are hitting memory issues in the browser, 
                    // then revoking the created object URLs could free some memory
                    // this._printWindow.addEventListener("pagehide", this._unloadPrint);
                    this._currentDocId = request.DocHandle;
                    if (request.hasOwnProperty('Document'))
                        this._currentDoc = request.Document;
                    let url = '/OnBaseDocument.ashx?wmode=transparent&id=' + this._currentDocId;
                    this._core.Loader.genericServiceCallRawData(url, this._printRawDocument, this._rawDocError);
                };
                this._rawDocError = () => {
                    this._log.info("DocActionPrint._rawDocError()");
                    if (this._printWindow) {
                        this._printWindow.close();
                    }
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    let msg = this._core.Locale.getTranslation("STR_WPT_DOC_FAILED_MSG") + ": " + this._currentDocId;
                    console.error(msg);
                    this._core.Helper.presentWarningModal(msg);
                };
                this._printRawDocument = (rawData) => {
                    this._log.info("DocActionPrint._printRawDocument()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + rawData.ContentType);
                    }
                    switch (rawData.ContentType) {
                        case 'application/pdf':
                            this._printPDFDocument(rawData.ContentRaw);
                            break;
                        default:
                            if (this._printWindow) {
                                this._printWindow.close();
                            }
                            if (this._modalSession) {
                                this._core.Helper.closeBusyModal(this._modalSession);
                                this._modalSession = null;
                            }
                            let msg = this._core.Locale.getTranslation("STR_WPT_DA_PRINT_WRONG_CONTENT_MSG") + ": " + rawData.ContentType;
                            console.error(msg);
                            this._core.Helper.presentWarningModal(msg);
                            break;
                    }
                };
                this._printPDFDocument = (pdfData) => {
                    this._log.info("DocActionPrint._printPDFDocument()");
                    this._printUrl = window.URL.createObjectURL(new Blob([pdfData], { type: 'application/pdf' }));
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created object URL: " + this._printUrl);
                    }
                    this._printWindow.location.href = this._printUrl;
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    // Let the system know we have (at least attempted to) printed
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(null, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_PRINTED);
                    navEvent.ActivationID = this._currentDocId;
                    navEvent.PrimaryContext = this._currentDoc;
                    navEvent.Layout = this._core.Navigation.Details.getActiveLayoutName();
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionPrint::constructor");
                this._label = this._core.Locale.getTranslation("STR_WPT_DA_PRINT");
            }
        }
        DocActions.DocActionPrint = DocActionPrint;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
